import { gql } from "graphql-request";

export const ADMIN_ANALYSIS_INTENT_TOP_BREAKDOWN = gql`
  query AdminAnalysisIntentTopBreakdown($filters: AdminAnalysisFiltersInput) {
    adminAnalysisIntentTopBreakdown(filters: $filters) {
      top
      topKo
      total
      subs {
        leaf
        sub
        subKo
        count
      }
    }
  }
`;

export const ADMIN_ANALYSIS_NEGATIVE_FEEDBACK = gql`
  query AdminAnalysisNegativeFeedback($filters: AdminAnalysisFiltersInput) {
    adminAnalysisNegativeFeedback(filters: $filters) {
      rows {
        label
        count
      }
      total
      userTotal
    }
  }
`;

export const ADMIN_ANALYSIS_POSITIVE_FEEDBACK = gql`
  query AdminAnalysisPositiveFeedback($filters: AdminAnalysisFiltersInput) {
    adminAnalysisPositiveFeedback(filters: $filters) {
      rows {
        label
        count
      }
      total
      userTotal
    }
  }
`;

export const ADMIN_ANALYSIS_MESSAGES = gql`
  query AdminAnalysisMessages($input: AdminAnalysisMessagesInput!) {
    adminAnalysisMessages(input: $input) {
      total
      rows {
        messageId
        sessionId
        role
        intent
        intentLabelKo
        negativeFeedbackLabel
        positiveFeedbackLabel
        messageCreatedAt
        contentPreview
        contentLength
      }
    }
  }
`;

export const ADMIN_ANALYSIS_SESSION = gql`
  query AdminAnalysisSession($id: String!) {
    adminAnalysisSession(id: $id) {
      session
      messages {
        original
        analysis
      }
    }
  }
`;
